<template>
    <div>
        <div>
                        <div>
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                Persönliche Informationen
                            </h3>
                        </div>
                        <div class="mt-6 md:grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                            <div class="col-span-6">
                                <label for="name" class="block text-sm font-medium text-gray-700">
                                    Name
                                </label>
                                <div class="mt-1">
                                    <input type="text" name="first_name" id="name" v-model="form.name" autocomplete="given-name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    <jet-input-error :message="form.errors.name" />
                                </div>
                            </div>

                            <hr class="col-span-6 my-2">
                            <p class="text-sm font-bold text-gray-400 col-span-6 m-0">(Wirklich optionale Elemente)</p>
                            <div class="col-span-6 md:-mt-4">
                                <label for="street" class="block text-sm font-medium text-gray-700">
                                    Straße und Hausnummer
                                </label>
                                <div class="mt-1">
                                    <input id="street" type="text" v-model="form.street" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                </div>
                            </div>

                            <div class="col-span-2">
                                <label for="city" class="block text-sm font-medium text-gray-700">
                                    Stadt
                                </label>
                                <div class="mt-1">
                                    <input type="text" id="city" v-model="form.city" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                </div>
                            </div>

                            <div class="sm:col-span-2">
                                <label for="postal" class="block text-sm font-medium text-gray-700">
                                    Postleitzahl
                                </label>
                                <div class="mt-1">
                                    <input type="text" id="postal" v-model="form.postal" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                </div>
                            </div>

                            <div class="sm:col-span-2">
                                <label for="country" class="block text-sm font-medium text-gray-700">
                                    Land
                                </label>
                                <div class="mt-1">
                                    <input type="text" name="state" id="country" v-model="form.country" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                </div>
                            </div>

                            <hr class="col-span-6 my-2">

                            <div class="col-span-6">
                                <label for="iban" class="block text-sm font-medium text-gray-700">
                                    IBAN
                                </label>
                                <div class="mt-1">
                                    <input type="text" id="iban" v-model="form.iban" autocomplete="given-name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    <jet-input-error :message="form.errors.iban" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pt-5 pr-8 pb-8">
                        <div class="flex justify-end">
                            <inertia-link :href="route('sepa.edit', {sepa: sepa})" type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Abbrechen
                            </inertia-link>
                            <button @click="getPDF" class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                SEPA-Mandat generieren
                            </button>
                        </div>
                    </div>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import InputError from "@/Jetstream/InputError";
import JetInputError from "@/Jetstream/InputError";

export default {
    name: "Create",
    components: {JetInputError},
    props: ['sepa', 'customer'],
    data () {
        return {
            form: this.$inertia.form({
                'name': this.customer?.name ?? '',
                'street': '',
                'city': '',
                'postal': '',
                'country': 'DE',
                'iban': '',
                'reference': this.customer?.next_sepa ?? '',
                'kdnr': this.customer?.kdnr ?? '',
            })
        }
    },
    methods: {
        getPDF() {
            this.form.post(route('sepa.validate', {sepa: this.sepa}),
                {
                    onSuccess: () => {
                        window.open(route('sepa.pdf', {sepa: this.sepa, debtor: encodeURI(btoa(JSON.stringify(this.form.data())))}), '_blank')
                    }
                }
            )
        }
    }
}
</script>

<style scoped>

</style>
